import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Utilities} from '../../utilities/utilities.model';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component({
	selector: 'amd-simple-table',
	templateUrl: './simple-table.component.html',
	styleUrls: ['./simple-table.component.scss']
})
export class SimpleTableComponent implements OnInit {

	@Input() amdSimpleTableParamsModel: AmdSimpleTableParamsModel;
	@Input() maxListSize = 5;

	@Input() tableClass = 'amd-table amd-table--highlight amd-table--bordered';
	@Input() showMoreTableTitle: string;

	@Input() headParams: AmdSimpleTableThParamsModel[];
	/**
	 * headRawValues must be a comma-separated list of strings
	 *  example:
	 * 	headRawValues="string1,string2,string3"
	 */
	@Input() headRawValues: string;
	@Input() headValues: string[];

	@Input() bodyParams: AmdSimpleTableThParamsModel[];
	@Input() bodyValues: string[][];

	@Output() clickItemEventEmitter: EventEmitter<number> = new EventEmitter<number>();
	@Output() clickShowMoreEventEmitter: EventEmitter<AmdSimpleTableParamsModel> = new EventEmitter<AmdSimpleTableParamsModel>();
	translateContext = TranslateContext;


	constructor() {
	}

	ngOnInit() {
		if (!Utilities.isVoid(this.amdSimpleTableParamsModel)) {
			this.tableClass = this.amdSimpleTableParamsModel.tableClass;
			this.showMoreTableTitle = this.amdSimpleTableParamsModel.showMoreTableTitle;
			this.headParams = this.amdSimpleTableParamsModel.headParams;
			this.headValues = this.amdSimpleTableParamsModel.headValues;
			this.bodyParams = this.amdSimpleTableParamsModel.bodyParams;
			this.bodyValues = this.amdSimpleTableParamsModel.bodyValues;
		} else {
			if (Utilities.isVoid(this.headRawValues)) {
				throw new Error('headRawValues is void');
			}
			this.headValues = this.headRawValues.split(',');

			this.amdSimpleTableParamsModel = new AmdSimpleTableParamsModel();
			this.amdSimpleTableParamsModel.tableClass = this.tableClass;
			this.amdSimpleTableParamsModel.showMoreTableTitle = this.showMoreTableTitle;
			this.amdSimpleTableParamsModel.headParams = this.headParams;
			this.amdSimpleTableParamsModel.headValues = this.headValues;
			this.amdSimpleTableParamsModel.bodyParams = this.bodyParams;
			this.amdSimpleTableParamsModel.bodyValues = this.bodyValues;
		}

		if (Utilities.isVoid(this.headValues)) {
			throw new Error('headValues is void');
		}

		if (Utilities.isVoid(this.headParams)) {
			throw new Error('headParams is void');
		}
		if (this.headValues.length !== this.headParams.length) {
			throw new Error('headValues\'s length mismatch with headParams\'s length');
		}

		if (Utilities.isVoid(this.bodyValues)) {
			throw new Error('bodyValues is void');
		}

		if (Utilities.isVoid(this.bodyParams)) {
			throw new Error('bodyParams is void');
		}

		if (this.bodyParams.length !== this.headParams.length) {
			throw new Error('bodyParams\'s length mismatch with headParams\'s length');
		}
	}
}

export class AmdSimpleTableParamsModel {
	tableClass: string;
	showMoreTableTitle: string;

	headParams: AmdSimpleTableThParamsModel[];
	headValues: string[];

	bodyParams: AmdSimpleTableThParamsModel[];
	bodyValues: string[][];
}

export class AmdSimpleTableThParamsModel {
	width: string;
	cursor?: string;
	class: string;
}
